import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import HomeContact from '../container/HomeContainer/HomeContact'
import ServiceOne from '../container/PagesContainer/ServiceOne'
import Footer from '../footer/Footer'
import MainNavigation from '../nav/MainNavigation'
import SEO from '../SEO/SEO'

function Services() {
    return (
        <React.Fragment>
            <SEO title="Dr Bupathi Gastro and Laparoscopy || Services" />
            <MainNavigation />
            <Breadcrumb image="/images/pages/services/serv.jpg" title="Home" content="Services" />
            <ServiceOne />
            <HomeContact />
            <Footer />
        </React.Fragment>
    )
}

export default Services